import clsx from "clsx";

import { type TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { type ColumnDef } from "@features/sales-v3/hooks/use-table-columns";

import {
  ACTUAL_WEEKLY_SPEND_ID,
  BUDGETED_WEEKLY_SPEND_ID,
  FIXED_NAME_COLUMN_ID,
  FIXED_STATUS_COLUMN_ID,
  PACING_STATUS_COLUMN_ID,
  SPEND_THERMOMETER_ID,
  TOTAL_BUDGET_COLUMN_ID,
} from "../constants";

import { ColumnMenu } from "./column-menu";
import { SpendTrackerHeaderContent } from "./table-header-spend-tracker-content";
import { TotalBudgetHeaderContent } from "./table-header-total-budget-content";

const LEFT_ALIGNED = [
  FIXED_NAME_COLUMN_ID,
  FIXED_STATUS_COLUMN_ID,
  BUDGETED_WEEKLY_SPEND_ID,
  ACTUAL_WEEKLY_SPEND_ID,
  PACING_STATUS_COLUMN_ID,
];

export const TableHeaderContent = ({
  column,
  children,
  ...restProps
}: TableHeaderRow.ContentProps) => {
  const columnDef = column as ColumnDef;

  if (column.name === SPEND_THERMOMETER_ID) {
    return (
      <SpendTrackerHeaderContent {...{ column, children, ...restProps }} />
    );
  } else if (column.name === TOTAL_BUDGET_COLUMN_ID) {
    return <TotalBudgetHeaderContent {...{ column, children, ...restProps }} />;
  }

  return (
    <>
      <div
        className={clsx("text-xs w-full flex items-center px-2", {
          "justify-end": !LEFT_ALIGNED.includes(columnDef.name),
        })}
      >
        <span
          className={clsx("overflow-hidden min-w-[10px]", {
            "flex-1": LEFT_ALIGNED.includes(columnDef.name),
          })}
        >
          {columnDef.id === FIXED_NAME_COLUMN_ID ? null : children}
        </span>
      </div>
      <ColumnMenu column={columnDef} />
      <div className="header-column-separator"></div>
    </>
  );
};
